/* eslint-disable @next/next/no-img-element */
import React, { ReactNode } from 'react';

import { NewMenuItem } from 'ui/src/data/MenuItem';
import { AllIcons } from 'ui/src/components/Icon';
import HeaderContainer, { type HeaderProps } from './HeaderContainer';
import HeaderBGEnum from './HeaderBGEnum';
import { HeaderContextProvider } from './_context';
import HeaderContent from './HeaderContent';

export type BairesDevHeaderProps = HeaderProps & {
  menuItems: NewMenuItem[];
  logoPath: string;
  headerLogoUrl?: string;
  headerLinkChildren?: ReactNode;
  ctaLabel?: string;
  ctaLink?: string;
  ctaIconName?: AllIcons;
  bgHeader?: HeaderBGEnum;
};

function BairesDevHeader({
  bgHeader = HeaderBGEnum.Light,
  menuItems,
  logoPath,
  enableHeaderBehavior,
  animatedHeader,
  headerLogoUrl = process.env.NEXT_PUBLIC_HOSTNAME,
  headerLinkChildren = null,
  ctaLabel = 'Schedule a Call',
  ctaLink = 'https://www.bairesdev.com/start/basic-details/',
  ctaIconName = undefined,
}: BairesDevHeaderProps) {
  return (
    <HeaderContextProvider bgHeader={bgHeader}>
      <HeaderContainer enableHeaderBehavior={enableHeaderBehavior} animatedHeader={animatedHeader}>
        <HeaderContent
          menuItems={menuItems}
          logoPath={logoPath}
          headerLogoUrl={headerLogoUrl}
          headerLinkChildren={headerLinkChildren}
          ctaLabel={ctaLabel}
          ctaLink={ctaLink}
          ctaIconName={ctaIconName}
        />
      </HeaderContainer>
    </HeaderContextProvider>
  );
}

export default BairesDevHeader;
